// extracted by mini-css-extract-plugin
export default {"encapsulador":"background_encapsulador__awx1l","imagen":"background_imagen__zg2Cw","hidden":"background_hidden__qb8rG"};